<template>
  <div class="w-100 not-found">
    <b-container class="w-100">
      <b-row>
        <b-col class="page-not-found-text" sm="6">
          <span class="oops">
            Oops,
            <br />
          </span> It looks like you're lost!
          <br />
          <span class="return-home">
            <router-link to="/home">Click here&nbsp</router-link>to return home.
          </span>
        </b-col>
        <b-col sm="6">
          <b-img-lazy class="w-100" src="../../public/img/icons/404.png"></b-img-lazy>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
body {
  background-color: #f2f2f2 !important;
}
.not-found {
  height: 80vh;
  padding-top: 100px;
  background-color: #f2f2f2;
  text-align: left;
}
.page-not-found-text {
  font-size: 3vw;
  margin: auto;
  color: #00264a;
}

.return-home {
  font-size: 2vw;
}

.oops {
  font-weight: bolder;
}

.footer-bs {
  margin-top: 0px !important;
}

@media screen and (max-width: 500px) {
  .page-not-found-text {
    font-size: 5vw;
  }
}
</style>

<script>
export default {};
</script>
